import { render, staticRenderFns } from "./JourneyTreeNode.vue?vue&type=template&id=074fa57a&scoped=true"
import script from "./JourneyTreeNode.vue?vue&type=script&lang=ts"
export * from "./JourneyTreeNode.vue?vue&type=script&lang=ts"
import style0 from "./JourneyTreeNode.vue?vue&type=style&index=0&id=074fa57a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074fa57a",
  null
  
)

export default component.exports